import { GLOBAL_NAV_ITEMS } from "@/lib/navigation";

export const TIMELINE = [
  {
    year: "2000",
    title: "시작은 2000년이었어요",
    desc: "글로벌미디어학부가 신설되면서,\n게임을 사랑하는 학생들이 모여\n게임웍스가 탄생했어요.",
  },
  {
    year: "2017",
    title: "혼자보다 함께를 택했어요",
    desc: "언타이틀과 손잡고 게언절 해커톤을 열었어요.",
  },
  {
    year: "2020",
    title: "직접 만들고, 직접 겨뤘어요",
    desc: "제1회 천하제일 창작대회가 열렸어요.\n각자 지식을 바탕으로 가치를 창출했어요.",
  },
  {
    year: "2024",
    title: "경계를 넘어 더 크게 만들었어요",
    desc: "디자인솔솔, 언타이틀과 함께 연합 해커톤 WISH를 열었어요.",
  },
  {
    year: "2025",
    title: "아이디어가 창업까지 이어졌어요",
    desc: "Flow: Startup Bridge를 시작했어요.\n아이디어가 투자 피칭까지 가는 경험을 처음 만들었어요.",
  },
];

export const NAV_ITEMS = GLOBAL_NAV_ITEMS;

export const FOOTER_LINKS = [
  { label: "홈", id: "home" },
  { label: "활동", id: "event" },
  { label: "연혁", id: "history" },
  { label: "임원진", id: "people" },
];

export const FOOTER_CONTACTS = [
  "Instagram",
  "Discord",
  "~~~@gmail.com",
  "000 : 010-0000-0000",
];
